var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCarsTransp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.001 28.102C42.001 27.6742 41.8638 27.2578 41.6097 26.9137L34.481 17.2626C32.9727 15.2205 30.5847 14.0156 28.0461 14.0156L8.00098 14.0156C6.89641 14.0156 6.00098 14.9111 6.00098 16.0156L6.00098 32.0156C6.00098 33.1202 6.89641 34.0156 8.00097 34.0156H8.1828L8.1828 38.0156H8.00097C4.68726 38.0156 2.00098 35.3293 2.00098 32.0156L2.00098 16.0156C2.00098 12.7019 4.68727 10.0156 8.00098 10.0156L28.0461 10.0156C31.8541 10.0156 35.436 11.823 37.6985 14.886L44.8272 24.5372C45.5896 25.5693 46.001 26.8187 46.001 28.102V32.0156C46.001 35.3293 43.3147 38.0156 40.001 38.0156H35.4555V34.0156H40.001C41.1055 34.0156 42.001 33.1202 42.001 32.0156V28.102Z",
    fill: "#15D4B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.001 36.0156C16.001 34.9111 16.8964 34.0156 18.001 34.0156H26.001C27.1055 34.0156 28.001 34.9111 28.001 36.0156C28.001 37.1202 27.1055 38.0156 26.001 38.0156H18.001C16.8964 38.0156 16.001 37.1202 16.001 36.0156Z",
    fill: "#15D4B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.001 6.01563C19.1055 6.01563 20.001 6.91106 20.001 8.01562V12.0156C20.001 13.1202 19.1055 14.0156 18.001 14.0156C16.8964 14.0156 16.001 13.1202 16.001 12.0156V8.01562C16.001 6.91106 16.8964 6.01562 18.001 6.01563Z",
    fill: "#15D4B6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.001 24.0156C43.001 25.1202 42.1055 26.0156 41.001 26.0156H34.001C30.6873 26.0156 28.001 23.3293 28.001 20.0156V14.0156C28.001 12.9111 28.8964 12.0156 30.001 12.0156C31.1055 12.0156 32.001 12.9111 32.001 14.0156V20.0156C32.001 21.1202 32.8964 22.0156 34.001 22.0156H41.001C42.1055 22.0156 43.001 22.9111 43.001 24.0156Z",
    fill: "#15D4B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.001 38.0156C13.1055 38.0156 14.001 37.1202 14.001 36.0156C14.001 34.9111 13.1055 34.0156 12.001 34.0156C10.8964 34.0156 10.001 34.9111 10.001 36.0156C10.001 37.1202 10.8964 38.0156 12.001 38.0156ZM12.001 42.0156C15.3147 42.0156 18.001 39.3293 18.001 36.0156C18.001 32.7019 15.3147 30.0156 12.001 30.0156C8.68727 30.0156 6.00098 32.7019 6.00098 36.0156C6.00098 39.3293 8.68727 42.0156 12.001 42.0156Z",
    fill: "#15D4B6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.001 38.0156C33.1055 38.0156 34.001 37.1202 34.001 36.0156C34.001 34.9111 33.1055 34.0156 32.001 34.0156C30.8964 34.0156 30.001 34.9111 30.001 36.0156C30.001 37.1202 30.8964 38.0156 32.001 38.0156ZM32.001 42.0156C35.3147 42.0156 38.001 39.3293 38.001 36.0156C38.001 32.7019 35.3147 30.0156 32.001 30.0156C28.6873 30.0156 26.001 32.7019 26.001 36.0156C26.001 39.3293 28.6873 42.0156 32.001 42.0156Z",
    fill: "#15D4B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarsTransp);
export default __webpack_public_path__ + "static/media/iconCarsTransp.4a301de760599a09174ff59929b1de10.svg";
export { ForwardRef as ReactComponent };